import React, { useRef, useState, useEffect } from "react";
import { Modal, Paper, Typography, Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const PolicyModal = ({ open, onClose, onReadComplete, t, policyVersion }) => {
  const scrollRef = useRef(null);
  const [atBottom, setAtBottom] = useState(false);
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  useEffect(() => {
    if (!open) setAtBottom(false);
  }, [open]);

  const onScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    const bottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 8;
    setAtBottom(bottom);
  };

  const handleAccept = () => {
    if (atBottom) {
      onReadComplete && onReadComplete();
      onClose && onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Paper sx={{ p: 3, maxWidth: 720, mx: "auto", my: 5, maxHeight: "85vh" }}>
        <Typography variant="h6" mb={1} textAlign={isArabic ? "right" : "left"}>
          {t("policy.title", { defaultValue: isArabic ? "Ø³ÙŠØ§Ø³Ø© Ø§Ù„Ø®ØµÙˆØµÙŠØ© â€“ ALGermanist" : "Privacy Policy â€“ ALGermanist" })}
        </Typography>

        {/* Scrollable content */}
        <Box
          ref={scrollRef}
          onScroll={onScroll}
          sx={{
            border: "1px solid #eee",
            p: 2,
            height: 380,
            overflow: "auto",
            borderRadius: 1,
            mb: 2,
            direction: isArabic ? "rtl" : "ltr",
          }}
        >
          <Typography variant="body2" color="text.secondary" gutterBottom textAlign={isArabic ? "right" : "left"}>
            {t("policy.effectiveDateLabel", { defaultValue: isArabic ? "ØªØ§Ø±ÙŠØ® Ø§Ù„Ù†ÙØ§Ø°" : "Effective Date" })}: {policyVersion}
          </Typography>
          <Box sx={{ whiteSpace: "pre-line", textAlign: isArabic ? "right" : "left" }}>
            {(() => { const raw = t("policy.content", { defaultValue: isArabic ? "يرجى مراجعة سياسة الخصوصية باللغة العربية هنا." : "Please review the Privacy Policy content here.", }); return raw.replace(/\\n/g, "\n"); })()}
          </Box>
        </Box>

        <Button
          fullWidth
          variant={atBottom ? "contained" : "outlined"}
          disabled={!atBottom}
          onClick={handleAccept}
        >
          {atBottom ? t("signup.agreeTerms") : t("signup.mustReadFirst")}
        </Button>
      </Paper>
    </Modal>
  );
};

export default PolicyModal;

